import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import moment from "moment";
import log from '../../../helpers/logger'
import { auth, getCurrentUser } from '../../../helpers/auth'
import { getTimeStamp, getUUIDV4 } from '../../../helpers/utils'
import {
  createPublisher,
  updatePublisher,
  deletePublisher,
  getPublisher,
  getPublisherList } from '../../../services/PublisherService'

function setErrorMsg(error) {
  return {
    errorMsg: error.message
  }
}

export default class PublisherPageList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMsg: null,
      currentUser: null,
      isLoading: true,
      dataList: []
    };

  }

  componentWillMount() {
    log.debug('componentWillMount')
  }
  async componentDidMount(){
    log.debug('componentDidMount')
    let user = await getCurrentUser();
    this.setState({currentUser: user})

    let dataList = await getPublisherList();
    /*
    log.debug(dataList.length)
    dataList.forEach(function(doc) {
        log.debug(doc.id, " => ", doc.data());
    });
    */

    log.debug('all data is loaded.')
    this.setState({dataList: dataList})
    this.setState({isLoading: false})
  }
  handleSubmit = async (e) => {
    e.preventDefault()
    log.debug(this.publisher_uuid.value);
    log.debug(this.state.value);
  }

  render () {

    let content;

    if (this.state.isLoading) {
      content = <div>Loading...</div>;
    } else {
      content =
      <div>
          <h4 className="page-header">
          <Link to='/publisher'>Publisher</Link> ->
          List
        </h4>
          <table className="table">
              <thead>
                  <tr>
                      {/* <th>publisher_id</th>
                      <th>publisher_uuid</th> */}
                      {/* <th>owner_id</th>
                      <th>tag</th> */}
                      <th>title</th>
                      {/* <th>description</th> */}
                      <th>date_created</th>
                      <th>status</th>
                      <th> Actions </th>
                  </tr>
              </thead>
              <tbody>
                {
                  this.state.dataList.map((data, index) =>
                  <tr key={index}>
                    {/* <td>{data.id}</td>
                    <td>{data.data().publisher_uuid}</td> */}
                    {/* <td>{data.data().owner_id}</td>
                    <td>{data.data().tag}</td> */}
                    <td>{data.data().title}</td>
                    {/* <td>{data.data().description}</td> */}
                    <td>{moment(data.data().date_created).fromNow()}</td>
                    <td>{data.data().status}</td>
                    <td>
                      <Link className="btn btn-small btn-primary" to={`/publisher/view/${data.id}`}>view</Link>
                    </td>
                  </tr>
                )
                }
              </tbody>
          </table>
          <p>
              <Link className="btn btn-success" to='/publisher/add'>Add New Publisher</Link>
          </p>
      </div>
    }


    return (
      <div>
          {content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/PublisherPage/PublisherPageList.js